var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import bAlert from "bootstrap-vue/es/components/alert/alert";
var AlertList = /** @class */ (function (_super) {
    __extends(AlertList, _super);
    function AlertList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localValue = _this.default ? window.messages : (_this.value || []);
        return _this;
    }
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], AlertList.prototype, "value", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], AlertList.prototype, "default", void 0);
    AlertList = __decorate([
        Component({
            name: "AlertList",
            components: {
                "alert": bAlert
            }
        })
    ], AlertList);
    return AlertList;
}(Vue));
export default AlertList;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/AlertList.vue
// module id = 15
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17